import script from "./newscenter.vue?vue&type=script&setup=true&lang=js"
export * from "./newscenter.vue?vue&type=script&setup=true&lang=js"

import "./newscenter.vue?vue&type=style&index=0&id=34d67488&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d67488"]])

export default __exports__